import { createSlice } from "@reduxjs/toolkit";
import i18n from "../i18n";

// Initialize language from URL first, then localStorage, then default to 'en'
const getInitialLanguage = () => {
  // Check URL first
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const langFromURL = urlParams.get("lang");
    if (langFromURL && ["en", "fr", "es", "it", "de", "cn"].includes(langFromURL)) {
      return langFromURL;
    }
  }
  // Fallback to localStorage
  const savedLanguage = localStorage.getItem("language");
  if (savedLanguage && ["en", "fr", "es", "it", "de", "cn"].includes(savedLanguage)) {
    return savedLanguage;
  }
  // Default to 'en'
  return "en";
};

const initialLanguage = getInitialLanguage();
if (i18n.language !== initialLanguage) {
  i18n.changeLanguage(initialLanguage);
}

const initialState = {
  language: initialLanguage,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload;
      localStorage.setItem("language", action.payload);
      // Sync with i18n immediately
      if (i18n.language !== action.payload) {
        i18n.changeLanguage(action.payload).catch((err) => {
          console.error("Failed to change language:", err);
        });
      }
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
